exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app__expire-support-notification {\n    position: fixed;\n    height: 48px;\n    z-index: 99999;\n    background: #ffdb43;\n    font-weight: 500;\n    font-size: 14px;\n    width: 100%;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-align-items: center;\n            align-items: center;\n    box-sizing: border-box;\n    font-family: HankenGroteskSemiBold,HankenGroteskSemiBoldOld,HelveticaNeue,Helvetica,Arial,sans-serif;\n    padding: 0 16px;\n}\n", ""]);

// exports
